import { createSlice } from '@reduxjs/toolkit';

import { IframeAppAuthSession } from './types';

interface AuthState {
  iframeUser: IframeAppAuthSession | null;
}

const initialState: AuthState = {
  iframeUser: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIframeUser(state, action: { payload: IframeAppAuthSession | null }) {
      state.iframeUser = action.payload;

      if (state.iframeUser) {
        state.iframeUser.expires_at = Math.floor(
          Date.now() / 1000 + state.iframeUser.expires_in
        );
      }
    },
  },
});

const { actions, reducer } = authSlice;

export const iframeUserSelector = (state: { auth: AuthState }) =>
  state.auth.iframeUser;

export const { setIframeUser } = actions;

export default reducer;
